import React from "react";
import "./ConfirmDeleteModal.css";
import { Close } from "@mui/icons-material";
import SubmitButton from "components/Button/SubmitButton";
import { Dialog, Paper, Tooltip } from "@mui/material";

const ConfirmDeleteModal = ({
  isModalOpen,
  onClose,
  onDelete,
  isLoading,
  modalTitleText,
  modalBodyText,
  maxWidth = "sm",
}) => {
  const confirmationHeader = modalTitleText ?? "Are you sure?";
  const confirmationText =
    modalBodyText ?? "Are you sure you want to delete this data?";

  return (
    <Dialog open={isModalOpen} onClose={onClose} fullWidth maxWidth={maxWidth}>
      <div className="upload-modal__container">
        <Paper>
          <div className="upload-modal__wrapper">
            <div style={{ display: "flex", alignItems: "center" }}>
              <h2>{confirmationHeader}</h2>
              <Tooltip title="Close" placement="bottom">
                <div onClick={onClose} className="upload-modal__close">
                  <Close />
                </div>
              </Tooltip>
            </div>

            <div className="confirm-delete-modal-text">
              <p>{confirmationText}</p>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <SubmitButton
                className="mt-2"
                variant="contained"
                color="error"
                isLoading={isLoading}
                handleClick={onDelete}
                buttonText="Delete"
              />
            </div>
          </div>
        </Paper>
      </div>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
